<template>
  <a-layout class="app" id="app">
    <a-layout-header class="app__header">
      <div class="app__logo">
        <svg width="38" height="65" viewBox="0 0 38 65">
          <path
            d="M30.6 36.9L31 36.6C31.4 36.3 31.7 36 32.1 35.6C35.7 32 37.6 27.6 37.6 22.3C37.6 19.2 36.9 16.4 35.7 13.9L29.1 17.7C29.7 19.1 30 20.6 30 22.3C30 25.5 28.9 28.2 26.8 30.3C24.7 32.4 22 33.5 18.9 33.5C15.8 33.5 13.2 32.4 11 30.3C8.9 28.2 7.8 25.5 7.8 22.3C7.8 19.1 8.9 16.4 11 14.3C13.1 12.2 15.8 11.1 18.9 11.1H25.5C26.4 11.2 29.5 11 32.3 9.2C32.6 9 32.9 8.7 33.3 8.4C34.8 7 36.6 4.4 36.6 0H29C29 1.4 28.7 2.4 28.1 2.9C27.3 3.7 25.9 3.7 25.7 3.7H18.8C13.6 3.6 9.1 5.4 5.5 9C1.8 12.7 0 17.1 0 22.3C0 27.6 1.8 32 5.5 35.6C9.1 39.2 13.6 41 18.8 41C20.1 41 21.4 40.9 22.7 40.7C26 41.7 29.1 44.1 29.1 48.5C29.1 53.8 24.9 57.4 18.8 57.4C12.9 57.2 8.4 53.8 8 49H0C0.3 58.3 7.9 64.7 18.7 64.7C29.7 64.7 37.1 58.1 37.1 48.4C37.1 43.1 35 39.4 30.6 36.9Z"
          />
        </svg>
      </div>
      <a-menu
        v-if="$route.path && $store.getters.logged"
        @click="handleMenu"
        mode="horizontal"
        class="app__menu"
        theme="dark"
        :style="{ lineHeight: '64px' }"
      >
        <a-sub-menu>
          <span slot="title">
            <a-icon type="appstore" />
            <span>Menu</span>
          </span>
          <a-menu-item key="/home">
            <a-icon type="home" />
            <span>Home</span>
          </a-menu-item>
          <a-menu-item v-if="isBasicUser" key="/design_customizations">
            <a-icon type="highlight" />
            <span>Design Customization</span>
          </a-menu-item>
          <a-menu-item v-if="isIllustrator" key="/fonts">
            <a-icon type="font-size" />
            <span>Fonts</span>
          </a-menu-item>
          <a-menu-item v-if="isRegisterUser" key="/similar_groups">
            <a-icon type="tablet" />
            <span>Similar Groups</span>
          </a-menu-item>
          <a-menu-item v-if="isRegisterUser" key="/mockups">
            <a-icon type="tablet" />
            <span>Mockups</span>
          </a-menu-item>
          <a-menu-item v-if="isAdmin" key="/admin">
            <a-icon type="user" />
            <span>Admin</span>
          </a-menu-item>
          <a-menu-item class="app__logout-menu" key="/logout">
            <a-icon type="logout" />
            <span>Logout</span>
          </a-menu-item>
        </a-sub-menu>
      </a-menu>
    </a-layout-header>
    <a-layout class="app__content">
      <a-layout-content class="" style="position: relative;">
        <router-view />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
export default {
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isAdvancedUser() {
      return this.$store.getters.isAdvancedUser;
    },
    isRegisterUser() {
      return this.$store.getters.isRegisterUser;
    },
    isIllustrator() {
      return this.$store.getters.isIllustrator;
    },
    isBasicUser() {
      return this.$store.getters.isBasicUser;
    },
  },
  mounted() {
    this.$store.dispatch("syncCoveragePrisma");
  },
  methods: {
    handleMenu(e) {
      const { key } = e;
      if (!key) return;
      if (this.$route.path !== key) this.$router.push(key);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
.app {
  width: 100%;
  height: 100%;
  background: $white;

  .app__header {
    display: flex;
    align-items: center;
    padding-left: 12px;
  }

  .app__logo {
    fill: $white;
    height: 100%;
    padding: 16px 0;
    display: flex;

    svg {
      height: 100%;
    }
  }

  .app__content {
    background: $white;
  }

  .app__logout-menu {
    background: $third_color;
    color: $white;
  }
}
</style>
